import { useQuery } from '@tanstack/react-query';

import PriceParrotService from '~/services/PriceParrotService';

import { parityTrendQueryKeys } from './parityTrendQueryKeys';

export function useGetParityTrendRangeSummary(
  offerBk: string | undefined,
  dateFrom: string | undefined,
  dateTo: string | undefined,
) {
  return useQuery({
    queryKey: parityTrendQueryKeys.summary(offerBk ?? '', dateFrom ?? '', dateTo ?? ''),
    queryFn: async ({ signal }) => {
      if (!offerBk || !dateFrom || !dateTo) {
        throw new Error('Parity trend summary requires offerBk, dateFrom, and dateTo');
      }
      const res = await PriceParrotService.getParityTrendRangeSummary(
        offerBk,
        { date_from: dateFrom, date_to: dateTo },
        signal,
      );
      return res.data;
    },
    enabled: Boolean(offerBk && dateFrom && dateTo),
  });
}
